'use strict';

import { EventBus } from '@global-js/event-bus';
import { updateBreadcrumbUrl } from '@modules/updateUrls';

// Update breacrumb URLs to IBE link
EventBus.$on('url:change', updateBreadcrumbUrl);
// Initial update of URLs
updateBreadcrumbUrl();
